import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmpJobMappingsService } from './logic/emp-job-mapping.service';
import { EmpJobMappingsLogicService } from './logic/emp-job-mapping/emp-job-mapping-logic.service';
import { EmpJobMappingsDaoService } from './dao/emp-job-mapping-dao.service';
import { EmpJobMappingsStorageDaoService } from './dao/emp-job-mapping/emp-job-mapping-storage-dao.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: EmpJobMappingsService, useClass: EmpJobMappingsLogicService },
    {
      provide: EmpJobMappingsDaoService,
      useClass: EmpJobMappingsStorageDaoService
    }
  ]
})
export class EmpJobMappingsModule {}
